import { loadSideSuggestions } from './sideSuggestions'
import { initNativeShareBox } from './nativeShareBox'
import { initializeWebplayer } from '../webplayer'
function isiPhone() {
    return (
        navigator.userAgent.includes('iPhone') ||
        navigator.userAgent.includes('iPod') ||
        navigator.userAgent.includes('iPad')
    )
}
const initSmartBanner = () => {
    if (isiPhone()) {
        return
    }
    const options = {
        onButtonClick: () => {
            console.log('open_app_top_link')
            sendGA4Event('open_app_top_link_click', { via: 'open_app_top_link_click', albumId: window.albumId })
        },
        onOpenApp: () => {
            console.log('redirect_installed_app')
            sendGA4Event('redirect_installed_app', { via: 'open_app_top_link_click', albumId: window.albumId })
        },
        onOpenWebsale: () => {
            console.log('redirect_offer_page')
            sendGA4Event('redirect_offer_page', { via: 'open_app_top_link_click', albumId: window.albumId })
        },
        appStoreLink:
            window.itunes_app_link || 'https://itunes.apple.com/us/app/tinytap-moments-into-games/id493868874',
        playStoreLink:
            window.google_play_app_link || 'https://play.google.com/store/apps/details?id=tinytap.kids.learning.games',
    }

    const smartBannerButton = document.querySelector('.smartbanner-button')
    if (smartBannerButton) {
        document.body.classList.add('smartbanner-show')

        smartBannerButton.addEventListener('click', () => {
            var linkRel =
                window.is_iOS === 'True'
                    ? options.appStoreLink
                    : window.is_android === 'True'
                    ? options.playStoreLink
                    : window.websaleLink

            var clickTs = Date.now()

            if (options.onButtonClick) {
                options.onButtonClick()
            }
            const appstoreLink = linkRel || window.websaleLink
            if (!window.appStoreLink) {
                // Fallback to websale
                var tempOptions = { ...options }
                var redirectionTimeout = setTimeout(function () {
                    var now = Date.now()
                    if (now - clickTs > 1500) {
                        if (tempOptions.onOpenApp) {
                            tempOptions.onOpenApp()
                        }
                        console.log('too much time passed - probably app opened')
                    } else {
                        // Couldn't open deeplink - go to websale
                        if (tempOptions.onOpenWebsale) {
                            tempOptions.onOpenWebsale()
                        }
                        window.location = window.websaleLink
                    }
                    clearTimeout(redirectionTimeout)
                }, 1000)

                window.location = window.appStoreLink
            } else {
                window.location = appstoreLink
            }
        })
    }
}

/*
const smartBannerConfiguration = {
    daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
    daysReminder: 0, // days to hide banner after "VIEW" button is clicked (defaults to 90)
    appStoreLanguage: 'us', // language code for the App Store (defaults to user's browser language)
    title: 'TinyTap',
    author: "Kids' Learning Games",
    button: 'Open App',
    store: {
        ios: 'On the App Store',
        android: 'In Google Play'
    },
    price: {
        ios: 'FREE',
        android: 'FREE'
    },
    goToLink: window.websaleLink,
    onButtonClick: () => {
        console.log('open_app_top_link');
        sendGA4Event('open_app_top_link_click', { via: 'open_app_top_link_click', albumId: window.albumId });
    },
    onOpenApp: ()=>{
        console.log('redirect_installed_app');
        sendGA4Event('redirect_installed_app', { via: 'open_app_top_link_click', albumId: window.albumId });
    },
    onOpenWebsale: ()=>{
        console.log('redirect_offer_page');
        sendGA4Event('redirect_offer_page', { via: 'open_app_top_link_click', albumId: window.albumId });
    }

}

if(window.appStoreLink){
    smartBannerConfiguration['appStoreLink'] = window.appStoreLink;
} else {
    smartBannerConfiguration['appStoreLink'] = window.websaleLink || "https://go.onelink.me/De6M/FromMobilePlayerPage";
}
*/

let descriptionIsOpen = false
let detailsContainer = null

function toggleDescription() {
    if (!detailsContainer) return

    if (descriptionIsOpen) {
        detailsContainer.classList.remove('open')
    } else {
        detailsContainer.classList.add('open')
    }
    descriptionIsOpen = !descriptionIsOpen
    if (descriptionIsOpen) {
        sendGA4Event('open_description_toggle', { albumId: window.albumId })
    }
}
/*

const registerScrollHandler = (element) => {
    let bottomBanner;
    const checkpoint = 200;
    element.addEventListener("scroll", function(ev){
        if (!bottomBanner) bottomBanner = document.querySelector('#albumPlayPageAds .bottomBanneLink');
        if(ev.target.scrollTop > checkpoint ){
            bottomBanner.classList.add('shown');
        } else {
            bottomBanner.classList.remove('shown');
        }
    });
}
*/

// alternative to DOMContentLoaded
document.onreadystatechange = function () {
    if (document.readyState == 'interactive') {
        window.handleGameClick = function (deepLink, albumLink) {
            const clickTs = Date.now()
            if (deepLink === window.websaleLink) {
                // No deeplink - Go to websale.
                sendGA4Event('redirect_offer_page', { via: 'suggestion_click', albumId: window.albumId })
                window.location = window.websaleLink
            } else {
                // Have deeplink - Open it.
                window.location = deepLink

                // Fallback to websale
                let redirectionTimeout = setTimeout(() => {
                    const now = Date.now()
                    if (now - clickTs > 1500) {
                        console.log('too much time passed - probably app opened')
                        sendGA4Event('redirect_installed_app', { via: 'suggestion_click', albumId: window.albumId })
                    } else {
                        // Couldn't open deeplink - go to websale
                        sendGA4Event(albumLink ? 'redirect_to_game' : 'redirect_offer_page', {
                            via: 'suggestion_click',
                            albumId: window.albumId,
                        })
                        window.location = albumLink || window.websaleLink
                    }
                    clearTimeout(redirectionTimeout)
                }, 1000)
            }
        }

        try {
            //new SmartBanner(smartBannerConfiguration);
            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        } catch (error) {
            // console.warn("SmartBanner won't load", error);
            var root = document.getElementsByTagName('html')[0]
            root.setAttribute('class', 'no-smartbanner')
        }

        const shareButton = document.querySelector('.albumShare .share.icon')
        if (navigator.share) {
            initNativeShareBox({
                shareButton: '.albumShare .share.icon',
                title: window.gameShareTitle,
                url: window.location.href,
            })
        } else {
            shareButton.style.display = 'none'
        }

        detailsContainer = document.querySelector('#albumPlayPage .albumPlayDetails')
        var descriptionToggle = detailsContainer.querySelector('.albumMainDetails')
        descriptionToggle.addEventListener('click', toggleDescription)
        //registerScrollHandler(detailsContainer);

        window.addEventListener(
            'orientationchange',
            function (event) {
                if (!event || !event.target || !event.target.screen || !event.target.screen.orientation) return
                const { type } = event.target.screen.orientation
                const orient = event.target.screen.orientation
                let isLandscape = orient && orient.type ? orient.type.includes('landscape') : window.orientation !== 0

                const isSmartAppBanner = document.querySelector('.smartbanner-show')
                if (isSmartAppBanner && isLandscape) {
                    document.body.scrollTop = 50 // For Safari
                    document.documentElement.scrollTop = 50 // For Chrome, Firefox, IE and Opera
                } else {
                    document.body.scrollTop = 1 // For Safari
                    document.documentElement.scrollTop = 1 // For Chrome, Firefox, IE and Opera
                }
            },
            false
        )

        initSmartBanner()

        initializeWebplayer()
        loadSideSuggestions(window.suggestionsCount)
        sendGA4Event('game_page_loaded')
    }
}

